import React from 'react';
import PropTypes from 'prop-types';
import { Row as FlexboxRow } from 'react-styled-flexboxgrid';
var propTypes = {
  /**
   * @ignore
   */
  children: PropTypes.node.isRequired
};

var Row = function Row(props) {
  return /*#__PURE__*/React.createElement(FlexboxRow, props, props.children);
};

Row.propTypes = propTypes;
export default Row;